

















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
	components: {
	},
})
export default class ListSubject extends Vue {
	@Prop({ default: false }) readonly white;
	@Prop({ default: null }) readonly width;
}
